import React, { useState } from "react";
import styled from "styled-components";
import { IoChevronBackSharp } from "react-icons/io5";
import {
  __,
  addNewStyle,
  CRISTP_ID,
  decode,
  defaultAvatar,
  encode,
  getUID,
  sendNotfication,
  toUSD,
  wait,
} from "../../../../Helper";
import axios from "axios";

// Styled Components
const MainContainer = styled.div`
  font-family: "Inter", -apple-system, BlinkMacSystemFont, sans-serif;
`;

const PopupContainer = styled.div`
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
  // max-width: 450px;
  // margin: 0 auto;
  background: linear-gradient(135deg, #1a1d21 0%, #2c3034 100%);
`;

const HeaderSection = styled.div`
  background: #2a2d33;
  padding: 20px 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.2),
      transparent
    );
  }
`;

const BackButton = styled.div`
  cursor: pointer;
  padding: 8px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
    transform: translateX(-2px);
  }

  svg {
    color: white;
    font-size: 20px;
  }
`;

const HeaderTitle = styled.h2`
  color: white;
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  // letter-spacing: -0.5px;

  @media (max-width: 450px) {
    font-size: 15px;
  }
`;

const ContentSection = styled.div`
  padding: 32px 24px;
  background: #1a1d21;

  @media (max-width: 450px) {
    padding: 20px 15px;
  }
`;

const FormCard = styled.div`
  background: linear-gradient(135deg, #2a2d32 0%, #1f2226 100%);
  border-radius: 16px;
  padding: 28px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  position: relative;

  @media (max-width: 450px) {
    padding: 20px 15px;
  }

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(76, 154, 255, 0.3),
      transparent
    );
  }
`;

const CurrencySection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  padding: 10px 20px;
  background: rgba(76, 154, 255, 0.05);
  border-radius: 8px;
  border: 1px solid rgba(76, 154, 255, 0.1);
`;

const CurrencyLabel = styled.div`
  color: #94a3b8;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 4px;
`;

const CurrencyInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const CurrencyIcon = styled.img`
  width: 20px;
  height: 20px;
  // border-radius: 50%;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
`;

const CurrencyText = styled.div`
  color: white;
  font-size: 14px;
  font-weight: 600;
`;

const InputGroup = styled.div`
  margin-bottom: 15px;
`;

const InputLabel = styled.label`
  display: block;
  color: #e2e8f0;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 3px;
  margin-left: 4px;

  @media (max-width: 450px) {
    font-size: 11px;
  }
`;

const StyledInput = styled.input`
  width: 100%;
  padding: 14px 20px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  color: white;
  font-size: 14px;
  transition: all 0.3s ease;
  box-sizing: border-box;

  @media (max-width: 450px) {
    padding: 10px 15px;
    font-size: 12px;
  }

  &::placeholder {
    color: #64748b;
  }

  // &:focus {
  //   outline: none;
  //   border-color: #4c9aff;
  //   background: rgba(76, 154, 255, 0.05);
  //   box-shadow: 0 0 0 4px rgba(76, 154, 255, 0.1);
  // }

  // &:hover:not(:focus) {
  //   border-color: rgba(255, 255, 255, 0.2);
  // }
`;

const SubmitButton = styled.button`
  width: 100%;
  padding: 15px 20px;
  background: linear-gradient(90deg, rgb(255, 215, 0), rgb(255, 140, 0));
  box-shadow: rgb(255, 168, 0) 0px -2px 0px inset;
  border: none;
  border-radius: 8px;
  color: white;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  // margin-top: 16px;
  position: relative;
  overflow: hidden;

  @media (max-width: 450px) {
    padding: 10px 15px;
    font-size: 12px;
  }

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.2),
      transparent
    );
    transition: left 0.5s ease;
  }

  &:hover::before {
    left: 100%;
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }
`;

const RulesSection = styled.div`
  margin-top: 32px;
  padding: 24px;
  background: rgba(220, 38, 38, 0.05);
  border-radius: 8px;
  border: 1px solid rgba(220, 38, 38, 0.1);
`;

const RulesTitle = styled.h4`
  color: #f87171;
  font-size: 14px;
  font-weight: 600;
  margin: 0 0 16px 0;
  display: flex;
  align-items: center;
  gap: 8px;

  @media (max-width: 450px) {
    font-size: 12px;
  }

  &::before {
    content: "⚠️";
    font-size: 16px;
  }
`;

const RuleItem = styled.div`
  color: #cbd5e1;
  font-size: 12px;
  line-height: 1.6;
  margin-bottom: 12px;
  padding-left: 20px;
  position: relative;

  @media (max-width: 450px) {
    font-size: 10px;
  }

  &::before {
    content: "•";
    color: #f87171;
    font-weight: bold;
    position: absolute;
    left: 0;
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

const LoadingSpinner = styled.div`
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: white;
  animation: spin 1s ease-in-out infinite;
  margin-right: 8px;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

function Withdrawpayment({ onClose }) {
  const [amount, setAmount] = useState("");
  const [qrManualDepositVisible, setQrManualDepositVisible] = useState(false);
  const [utrNumber, setUtrNumber] = useState("");
  const [depositPaymentSetting, setDepositPaymentSetting] = useState({});
  const [step, setStep] = useState(1);
  const [depositType, setDepositType] = useState("manual");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!amount || !utrNumber) {
      sendNotfication("Please fill all fields", "danger", "bottom-left");
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(
        "https://api.betbazaar365.com/payment/api/withdrawal/manual",
        {
          money: parseFloat(amount),
          uid: String(getUID),
          upiId: utrNumber,
        }
      );

      const data = response?.data;

      if (!data) {
        sendNotfication(
          "Something went wrong! Please try again.",
          "danger",
          "bottom-left"
        );
        setLoading(false);
        return;
      }

      if (data?.status === false) {
        sendNotfication(
          data?.message || "Payment failed! Please try again.",
          "danger",
          "bottom-left"
        );
        setLoading(false);
        return;
      }

      if (data.status === true) {
        sendNotfication(data.message, "success", "bottom-left");
        setAmount("");
        setUtrNumber("");
      } else {
        sendNotfication(
          "Payment URL is missing! Please contact support.",
          "danger",
          "bottom-left"
        );
      }
    } catch (error) {
      console.error("Error during gateway withdrawal:", error);
      sendNotfication(
        "An unexpected error occurred! Please try again later.",
        "danger",
        "bottom-left"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <MainContainer>
      <PopupContainer>
        <HeaderSection>
          {onClose && (
            <BackButton onClick={onClose}>
              <IoChevronBackSharp />
            </BackButton>
          )}
          <HeaderTitle>Manual Withdraw</HeaderTitle>
        </HeaderSection>

        <ContentSection>
          <FormCard>
            <CurrencyLabel>Withdraw Currency</CurrencyLabel>
            <CurrencySection>
              <div>
                <CurrencyInfo>
                  <CurrencyIcon src="assets/bcimages/INR.webp" alt="INR" />
                  <CurrencyText>INR</CurrencyText>
                </CurrencyInfo>
              </div>
            </CurrencySection>

            <InputGroup>
              <InputLabel>Amount</InputLabel>
              <StyledInput
                type="number"
                placeholder="Enter Amount (₹)"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
              />
            </InputGroup>

            <InputGroup>
              <InputLabel>UPI ID</InputLabel>
              <StyledInput
                type="text"
                placeholder="Enter your UPI ID (e.g., user@paytm)"
                value={utrNumber}
                onChange={(e) => setUtrNumber(e.target.value)}
              />
            </InputGroup>

            <SubmitButton onClick={handleSubmit} disabled={loading}>
              {loading && <LoadingSpinner />}
              {loading ? "Processing..." : "Submit Withdraw"}
            </SubmitButton>

            <RulesSection>
              <RulesTitle>Important Guidelines</RulesTitle>
              <RuleItem>
                Withdrawal limit: ₹500-₹10,000 (30 min processing), Above
                ₹10,000 (24 hrs processing)
              </RuleItem>
              <RuleItem>
                Your transfer amount must MATCH the submission amount exactly
              </RuleItem>
              <RuleItem>
                Each Order ID can ONLY be used once to avoid duplicates
              </RuleItem>
              <RuleItem>
                Please follow the withdrawal guidelines carefully, otherwise
                your withdrawal may be delayed
              </RuleItem>
            </RulesSection>
          </FormCard>
        </ContentSection>
      </PopupContainer>
    </MainContainer>
  );
}

export default Withdrawpayment;
